import { apiClient } from './client';

export interface TemplateItem {
  id: string;
  _type: 'timeline' | 'checklist' | 'kibuddim' | 'questionnaire';
  isTemplate: boolean;
  templateName: string | null;
  title: string | null;
  description: string | null;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
  sections: unknown[];
  /** Timeline + questionnaire templates: associated event type. */
  eventTypeId?: string | null;
  eventType?: { id: string; name: string } | null;
  /** Questionnaire templates: linked timeline template. */
  timelineTemplateId?: string | null;
  timelineTemplate?: { id: string; templateName: string | null; title: string | null } | null;
}

export async function listTemplates(
  type?: string,
  includeArchived = false,
): Promise<TemplateItem[]> {
  const params: Record<string, string> = {};
  if (type) params.type = type;
  if (includeArchived) params.includeArchived = 'true';
  const { data } = await apiClient.get<TemplateItem[]>('/event-ops/templates', { params });
  return data;
}

export async function saveAsTemplate(
  id: string,
  templateName: string,
  type: string,
): Promise<TemplateItem> {
  const { data } = await apiClient.post<TemplateItem>(`/event-ops/${id}/save-as-template`, {
    templateName,
    type,
  });
  return data;
}

export async function archiveTemplate(id: string, type: string): Promise<void> {
  await apiClient.patch(`/event-ops/${id}/archive`, null, { params: { type } });
}
